import { render } from "./DebatersArticle.vue?vue&type=template&id=1d22b19c"
import script from "./DebatersArticle.vue?vue&type=script&lang=js"
export * from "./DebatersArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__